import type { FaireProductEntity } from "../../entity_types/product";

export const p_5az3q9z5hc: FaireProductEntity = {
  token: "p_5az3q9z5hc",
  type: "product",
  name: "Kids Color Pop Fizzing Bath Dust",
  brandToken: "b_g4k2kqs2t6",
  brandName: "570 Soap Company",
  imageUrl:
    "https://cdn.faire.com/fastly/8924421ebc68239b0ddb722004c14af3cf0c018ead4edaeaef74d4edb3269592.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ab61306fd3fbc4297a9ace4297b64f070bb575600c24163514f40719dbec7c09.jpeg",
    "https://cdn.faire.com/fastly/b05cf2890cb023698244420381761b96d5b58483368573bbe007795c7d690a47.jpeg",
    "https://cdn.faire.com/fastly/ec503e3f9084a54b0e337321d4f5ce6f57a7e2edf60043300eecc554f5a4aaa6.jpeg",
    "https://cdn.faire.com/fastly/6c9ebfbca5aab68ed20323fee14062df6f2ea52cb2a4a7aeb56815faa1b71525.jpeg",
    "https://cdn.faire.com/fastly/5295c4336b79e4e62018127b79bbea55e42c06611400f647cd3f2c445bca1852.jpeg",
    "https://cdn.faire.com/fastly/b53813db4ad38688b9a51e1b9040087e96cb45c3d31c8b6fb121b6ddbe8a14fa.jpeg",
    "https://cdn.faire.com/fastly/bd712cd45431ca22c0eab0ab397435f77fb989f405c9af000efab6060180dedf.jpeg",
    "https://cdn.faire.com/fastly/6af5f355a5831bfd2781fc0c53091b319affefaccd9d39b8159425acba826118.jpeg",
    "https://cdn.faire.com/fastly/9c27b1ea937a469d6abfaacabeaee2e1b06d8bb0c46d67ecfe8fdef840cf71e7.jpeg",
    "https://cdn.faire.com/fastly/600a91a724cd119b4cf703652b0905757224f81fe24ca997a4034e1c6ab7de02.jpeg",
  ],
  priceDollars: 2.4,
  description:
    "\nKids Color Pop Fizzing Bath Dust: Turn Bath Time into a Vibrant Adventure!\n\nIntroducing our Kids Color Pop Fizzing Bath Dust, the ultimate bath time treat that transforms ordinary baths into colorful, fizzy fun! Designed to add an exciting twist to your little one's bathing routine, this bath dust comes in a convenient packet, allowing you to control the intensity of the colors and create a playful, vibrant experience that kids will adore.\n\nKey Features:\n\n * Fizzing Fun: Watch in awe as the bath water fizzes and bubbles with excitement, turning each bath into a dazzling display of color and joy. \n * Colorful Adventure: Choose how vibrant you want the bath to be by adjusting the amount of bath dust you use, giving you complete control over the color intensity.",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:57.575Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
